import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APIScadenzeStandard {

  getUrlDomain(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = location.protocol + "//" + location.hostname + "/";

    }

    return result + nome_metodo;


  }

  async initDDL(user) {

    let formData = new FormData();

    formData.append("username", user);

    return axios.post(this.getUrlDomain("EmtAgilaCtrlsInitDDLApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async getInfoAzienda(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("v_id", id);

    return axios.post(this.getUrlDomain("EmtAgilaSediOpGetInfoAzApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async saveSedeOperativa(sede_operativa, user, id) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);

    for (var key in sede_operativa) {
      formData.append(key, sede_operativa[key]);
    }

    return axios.post(this.getUrlDomain("EmtAgilaSaveSediOpApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  async editScadenzaStandard(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("id", id);


    return axios.post(this.getUrlDomain("EmtAgilaEditScadStandApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  async deleteScadenzaStandard(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);


    return axios.post(this.getUrlDomain("EmtAgilaDeleteScadStandApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  // async insertScadenzaStandard(scadenza_standard, user) {

  //   let formData = new FormData();

  //   formData.append("username", user);

  //   for (var key in scadenza_standard) {
  //     formData.append(key, scadenza_standard[key]);
  //   }

  //   return axios.post(this.getUrlDomain("EmtAgilaInsScadStandApi"), formData, { 'Content-Type': 'multipart/form-data' });

  // }

  async insertScadenzaStandard(scadenza_standard, user) {

    let formData = new FormData();

    formData.append("username", user);

    for (var key in scadenza_standard) {
      formData.append(key, scadenza_standard[key]);
    }

    return axios.post(this.getUrlDomain("goInsertScadenzaStandard"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async updateScadenzaStandard(scadenza_standard, user, id) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);

    for (var key in scadenza_standard) {
      formData.append(key, scadenza_standard[key]);
    }

    return axios.post(this.getUrlDomain("EmtAgilaUpdScadStandApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async deleteCondizioni(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);

    return axios.post(this.getUrlDomain("EmtAgilaDeleteCtrlsCondApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async exportXls(user, curSrcText, curCompany, curPrjType, curCtrType, curStatus) {

    let formData = new FormData();

    formData.append("username", user);

    formData.append("curSrcText", curSrcText);
    formData.append("curCompany", curCompany);
    formData.append("curPrjType", curPrjType);
    formData.append("curCtrType", curCtrType);
    formData.append("curStatus", curStatus);


    return axios.post(this.getUrlDomain("EmtAgilaExportXlsCtrlsApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }



}

export default new APIScadenzeStandard({
  url: "https://services.ebadge.it/public/api/"
})
